import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const StyleHeaderMenu = styled.div`
  height: 4rem;
  width: 100%;
  padding: 0px 100px;
  background: ${(props: Props) => props.theme.palette.neutral.white};
  box-shadow: 0 0 7px 1px ${(props: Props) => props.theme.palette.neutral._400};
  display: flex;
  align-items: center;
`;

export const StyleLogo = styled.img`
  height: 35px;
  margin-right: 35px;
`;

export const StyleNavigation = styled.div`
display: flex;
flex-direction: row
`;

export const StyleHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
`;

export const StyleAnchor = styled.a`
  text-decoration: none;
`;

export const StyleLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props: Props) => props.theme.palette.neutral._60};
  i {
    color: ${(props: Props) => props.theme.palette.neutral.black};
  }
`;
